import styled from "styled-components";

import { ICON_HEIGHT } from "./_constants";

const IconBell = styled.img.attrs({
  src: "/assets/images/icon-bell.png",
  alt: "Bell icon"
})`
  cursor: pointer;
  height: ${ICON_HEIGHT}px;
`;
IconBell.displayName = "IconBell";

export default IconBell;
